import { Skeleton } from "@mui/material";
import React from "react";
import parseReactComponents from "../functions/parseReactComponents";
import { Container } from "@mui/system";

export default function PageContent({content}){

    return(
        <Container maxWidth='xl' 
            sx={{
                m:'3rem auto'
            }}
        >
            {content?
                parseReactComponents(content)
            :
                <>
                    <Skeleton variant='rectangular' height={40} sx={{ width:'80%' }}/>
                    <Skeleton variant='rectangular' height={60} sx={{ m:'1rem 0', width:'95%' }}/>
                    <Skeleton variant='rectangular' height={120} sx={{ m:'1rem 0', width:'90%' }}/>
                    <Skeleton variant='rectangular' height={40} sx={{ width:'85%' }}/>
                </>
            }
        </Container>
    );
}